import React, { useEffect, useRef, useState } from "react";
import useCalender from "../../hooks/useCalender";
import { useNavigate } from "react-router-dom";
import { cn, ImgIcon } from "../../utils/utils";
import { generateMenu } from "../../utils/MenuGenerator";
import DropDownBox from "../custom/DropDownBox/DropDownBox";
import useOutsideClick from "../../hooks/useOutsideClick";
import { coachgender } from "../../data/options";
import creataIcon from "../../assets/icons/CREATE.svg";
import { useGetAllCourtsByNameQuery } from "../../lib/redux/services/sections/Courts";
// import ClubsSidebar from './clubsSidebar/ClubsSidebar';
import useExport from "../../hooks/useExport";
import { toast } from "react-toastify";
import DynamicFilter, { FilterConfig } from "../global/DynamicFilter";
import { useSelector } from "react-redux";
import PrintButton from "../global/PrintButton";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import { UserSliceType } from "../../lib/redux/slices/userSlice";
import AddForIcon from "../../assets/icons/AddForIcon";
import CreateIcon from "../../assets/icons/CreateIcon";
import ImageIcon from "../global/ImageIcon";
import ExportIcon from "../../assets/icons/ExportIcon";
import FilterIcon from "../../assets/icons/FilterIcon";
import SearchIcon from "../../assets/icons/SearchIcon";

import { useDebounce } from "../../hooks/useDebounce";
import ExportButton from "../global/ExportButton";
import { MOBILE_VIEW_ENDPOINT } from "../../constants";
import PlusIcon from "../../assets/icons/PlusIcon";
import { useViewport } from "../../hooks/useViewport";
import SideBar from "../global/SideBar";
import SideBarButton from "../global/SideBarButton";
import WalletSidebar from "../wallet/WalletSidebar";
import { Tooltip } from "react-tooltip";
type Props = {
  updateDate: React.Dispatch<
    React.SetStateAction<{
      day: number;
      month: number;
      year: number;
    }>
  >;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  date: {
    day: number;
    month: number;
    year: number;
  };
  id: number |null;
  walletId:number;
  data: any;
  page: "players" | "memberships" | "packages" | "Vouchers";
  setPage: React.Dispatch<"players" | "memberships" | "packages" | "Vouchers">;
  setFilter: React.Dispatch<React.SetStateAction<Object>>;
  setCurrentPage: any;
  filter: any;
  search: any;
  getFunction: any;
  voucherType?:any
};
function WalletHeader({
  updateDate,
  date,
  id,
  data,
  filter,
  search,
  getFunction,
  page,
  walletId,
  setPage,
  setSearch,
  setFilter,
  setCurrentPage,
  voucherType
}: Props) {
  const { pricing, customers, inputs, shared, options }: DictionaryType =
    useGetDictionary();
  const { generateExcelFile } = useExport();
  const lang = useSelector((state: any) => state?.user?.lang);
  const [sidebarOpen] = useState<boolean>(false);

  const club_id = useSelector((state: any) => state.user.selectedClub);

  const Roles = useSelector(
    //@ts-ignore
    (state: UserSliceType) => state.user.currentPremission
  );
  const dropDownRef = useRef<HTMLButtonElement>(null);
  const [openDropDown, setOpenDropDown] = useState<boolean>(false);
  const navigate = useNavigate();
  const closeDropDown = () => {
    setOpenDropDown(false);
  };
  useOutsideClick(dropDownRef, closeDropDown);
  const test = (props: any) => {};
  const customersFilterConfig: FilterConfig = [
    {
      type: "select",
      name: "gender",
      label: inputs.gender,
      options: coachgender(options),
    },
    {
      type: "text",
      name: "email",
      label: inputs.email,
    },
    {
      type: "mobile",
      name: "mobile_number",
      label: inputs.phone_number,
    },
  ];
  const membershipFilterConfig: FilterConfig = [
    {
      type: "select",
      name: "status",
      label: inputs.status,
      options: [
        { label: inputs.enabled, value: "enabled" },
        { label: inputs.disabled, value: "disabled" },
      ],
    },
    {
      type: "text",
      name: "created_by",
      label: pricing.crated_by,
    },
    {
      type: "date",
      name: "date_added_from",
      label: inputs.date_add_from,
    },
    {
      type: "date",
      name: "date_added_to",
      label: inputs.date_add_to,
    },
  ];
  const FilterBox = [
    {
      name: "Filter",
      tag: "filter",
      icon: AddForIcon,
      action: "any",
      color: "#1e1850",
    },
  ];

  useOutsideClick(dropDownRef, closeDropDown);

  const filterDropDown = generateMenu(
    FilterBox,
    {},
    {
      filter: {
        //@ts-ignore
        component: (item, onClick, closeDropDown) => {
          return (
            <div
              className="h-fit max-h-[67vh]   overflow-y-auto customScroll px-3 py-2"
              //@ts-ignore
              ref={dropDownRef}
            >
              <div>
              
                <DynamicFilter
                  filter={filter}
                  setFilter={setFilter}
                  config={
                    page === "players"
                      ? customersFilterConfig
                      : membershipFilterConfig
                  }
                  onChange={(filters) => {
                    setFilter((prev) => {
                      return { ...prev, ...filters };
                    });
                  }}
                />
              </div>
            </div>
          );
        },
      },
    }
  );
  const clubId = useSelector((state: UserSliceType) => state.user.selectedClub);
  const { sizeInfo, isMobile, isLandscapeOrientation } = useViewport();
  return (
    <div className="">
      <div className="flex gap-4 items-center justify-end w-full overflow-x-auto customScroll py-2  mobile:flex-col-reverse ">
        <div className="flex gap-4 items-center ">
          <div className="controll flex gap-2 items-center flex-2  ">
            <div className="flex gap-0 items-center dark:bg-primaryLight p-2 rounded-2xl border border-main-1 mobile:w-[60%]">
              <ImageIcon
                Icon={SearchIcon}
                className="mobile:w-[25px] w-[35px]"
                width={35}
              />
              <input
                type="text"
                className="text-main-1 p-2 pl-1 font-normal tracking-wider mobile:text-sm text-lg outline-none border-none bg-transparent focus:border-none focus:outline-none w-auto monile:w-inherit "
                placeholder={shared.search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>
             <Tooltip
                id="filter-tooltip"
                style={{
                  backgroundColor: "#ccc",
                  color: "#1e1850",
                  fontWeight: "bold",
                  
                  top: "0px",
                  zIndex: 1000,
                }}
                place="top"
              />
             <button
                data-tooltip-id="filter-tooltip"
                data-tooltip-content="Filter"
              ref={dropDownRef}
              className="flex gap-2 items-center  dark:bg-primaryLight p-2 rounded-2xl border border-main-1 "
              onClick={() => setOpenDropDown((prev) => !prev)}
            >
              <ImageIcon
                className="min-w-[32px]"
                Icon={FilterIcon}
                width={32}
              />
            </button>

            {openDropDown && (
              <DropDownBox
                dropDownConfig={filterDropDown}
                title=""
                closeDropDown={closeDropDown}
                className="absolute top-[190px] ltr:right-[120px] rtl:left-[5px] z-50 w-fit dark:bg-primary"
              />
            )}
            <PrintButton />
            <ExportButton
              fileName={`${page} ${id}`}
              getFunction={getFunction}
              getFunctionParams={{
                club_id: clubId,
                clubId: clubId,
                  wallet_id: walletId,
                limit: 5000,
                name: useDebounce(search),
                ...filter,
              }}
            />
           

            {!(sizeInfo.currentWidth < MOBILE_VIEW_ENDPOINT) &&
              Roles?.find(
                (role: any) => role?.section?.toLowerCase() === "club customers"
              )?.create === true && voucherType === 'public' &&(
                <SideBarButton
                  headerTitle={"Sell a voucher"}
                  headerImage={creataIcon}
                  buttonTitle={"Sell a voucher"}
                  //@ts-ignore
                  SideBarChildren={
                    <WalletSidebar type="new" id={id!} page="users" />
                  }
                  buttonStyle="flex gap-2 items-center bg-primary dark:bg-primaryYellow dark:text-primary p-2 px-4 rounded-md border border-main-1 text-white"
                  sideBarMaxWidth={
                    page === "Vouchers" ? "max-w-[400px]" : "max-w-[400px]"
                  }
                  ButtonIcon={() => <CreateIcon />}
                />
              )}
          </div>
        </div>
      </div>
      {sizeInfo.currentWidth < MOBILE_VIEW_ENDPOINT &&
        !sidebarOpen &&
        Roles?.find(
          (role: any) => role?.section?.toLowerCase() === "club customers"
        )?.create === true && voucherType === 'public' &&(
          <SideBarButton
            headerTitle={"Add user to Wallet"}
            headerImage={creataIcon}
            buttonTitle={""}
            //@ts-ignore
            SideBarChildren={
              <WalletSidebar type="new" id={club_id} page="users" />
            }
            containerStyle="fixed w-[50px] h-[50px] rounded-full bg-primary bottom-[85px] right-5 text-white grid place-content-center cursor-pointer z-[40]"
            sideBarMaxWidth={
              page === "Vouchers" ? "max-w-[400px]" : "max-w-[400px]"
            }
            ButtonIcon={() => <PlusIcon width={"30px"} height={"30px"} />}
          />
        )}
    </div>
  );
}

export default WalletHeader;
